import React from 'react'

const content = {
	"Label": "Give your pipeline a memorable label.",
	"Settings": "Configure the runtime values for your pipeline. These will override any values defined on the workspace project components.",
	"Streams": "Configure the selected data streams/properties for your pipeline. Available for extractor components only.",
	"Actions": "By default, this pipeline will run all attached components sequentially. Select a custom sequence of plugins/commands or define a custom Bash script to take complete control of this pipeline's actions.",
	"Triggers": "Automatically run this pipeline on a schedule, or set to \"Manual\" if intended to be triggered by a user. Optionally specify what other pipelines or tasks should trigger a pipeline run on successful completion."
}

export const DataImportEditOverview = <>
	{Object.entries(content).map((c, i) => ((title: string, description: string) =>
		<React.Fragment key={i}>
			<h3>{title}</h3>
			<div>{description}</div>
			<br />
		</React.Fragment>)(...c))}
</>
